export var GoogleMapsApiConfig = {
  apiKeyResolver: null, // a promise that returns the API key
  libraries: null,
  version: null,
  callbackName: '__googleMapsApiOnLoadCallback',
  timeout: 20000
}

class GoogleMapsApiLoader {

  constructor() {
    this._apiPromise = null;
  }

  getApiKey() {
    return GoogleMapsApiConfig.apiKeyResolver()
  }

  getApi() {

    if(!this._apiPromise) {
      this._apiPromise = new Promise((resolve, reject) => {
        if (!GoogleMapsApiConfig.apiKeyResolver) {
          return reject(new Error('No API key resolver found for GoogleMapsApiLoader. This service must be configured using the GoogleMapsApiConfig export'));
        }

        // Check whether API is already loaded.
        if (window.google && window.google.maps) {
          resolve(window.google.maps);
        }
        else {
          return this.getApiKey()
            .then(apiKey => {
              // Prepare the `script` tag to be inserted into the page.
              var scriptElement = document.createElement('script');
              var params = [
                `callback=${GoogleMapsApiConfig.callbackName}`,
                `key=${apiKey}`
              ];
              var libraries = GoogleMapsApiConfig.libraries || [];
              if (libraries.length) params.push('libraries=' + libraries.join(','));
              if (GoogleMapsApiConfig.version) params.push('v=' + GoogleMapsApiConfig.version);
              scriptElement.src = 'https://maps.googleapis.com/maps/api/js?' + params.join('&');

              // Timeout if necessary.
              let timeoutId = null;
              if (GoogleMapsApiConfig.timeout) {
                timeoutId = window.setTimeout(() => {
                  window[GoogleMapsApiConfig.callbackName] = () => {}; // Set the on load callback to a no-op.
                  reject(new Error('Time out - Could not load the Google Maps API'));
                }, GoogleMapsApiConfig.timeout);
              }

              // Hook up the on load callback.
              window[GoogleMapsApiConfig.callbackName] = function () {
                if (timeoutId !== null) {
                  window.clearTimeout(timeoutId);
                }
                resolve(window.google.maps);
                delete window[GoogleMapsApiConfig.callbackName];
              };

              // Insert the `script` tag.
              document.body.appendChild(scriptElement);
            })
        }
      });
    }

    return this._apiPromise;
  }
}

export default new GoogleMapsApiLoader();